<template>
	<div>
		<el-card class="box-card">
			<el-form :inline="true">
				<el-form-item label="角色昵称">
					<el-input placeholder="请填写角色昵称" v-model="listQuery.search.nick_name" clearable>
					</el-input>
				</el-form-item>
			</el-form>
			<el-button type="primary" @click="keySearch">搜索</el-button>
			<el-button type="primary" style="margin-left:20px;" plain @click="resetSearch">重置搜索</el-button>
			<el-button type="success" @click="handleCreate">添加角色</el-button>
		</el-card>

		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column width="100" prop="id" label="ID"> </el-table-column>
				<el-table-column prop="nick_name" label="昵称"> </el-table-column>
				<el-table-column prop="des" label="描述"> </el-table-column>
				<el-table-column label="操作" fixed="right" with="250">
					<template slot-scope="{row,$index}">
						<el-button type="primary" size="mini" @click="handleUpdate(row)">编辑</el-button>
						<!-- <el-popconfirm @confirm="handleDelete(row,$index)" @onConfirm="handleDelete(row,$index)"
							title="确定删除该角色？">
							<el-button style="margin-left:10px;" type="danger" size="mini" slot="reference">删除
							</el-button>
						</el-popconfirm> -->
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
			<!-- 添加角色模态框 -->
			<el-dialog width="30%" title="设置角色" :visible.sync="is_show_create">
				<span>
					<el-form ref="form" label-width="120px" size="medium">

						<el-form-item label="角色名">
							<el-col :span="20">
								<el-input placeholder="请填写" v-model="create_data.nick_name" clearable> </el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="描述" style="margin-top:10px">
							<el-col :span="20">
								<textarea v-model="create_data.des"
									style="width:100%;border: 1px solid #dedede;height:100px"></textarea>
							</el-col>
						</el-form-item>
						<el-form-item label="权限">
							<el-col :span="12">
								<el-tree ref="tree" :check-strictly="checkStrictly" :data="routesData"
									:props="defaultProps" show-checkbox node-key="path" class="permission-tree" />
							</el-col>
						</el-form-item>
					</el-form>
				</span>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_create = false">返回</el-button>
					<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="createManager()">确定
					</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		roleList,
		roleSet,
		roleDel
	} from '@/api/sign_admin'
	import request from '@/tool/request'
	import {
		parseTime
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import {
		asyncRoutes
	} from '@/router'
	export default {
		components: {
			Pagination
		},
		data() {
			return {
				routesData: asyncRoutes,
				defaultProps: {
					children: 'children',
					label: 'title'
				},
				checkStrictly: false,
				create_data: null, // 角色表单数据
				total: 0, // 总条数
				listQuery: null,
				is_show_search: false, // 搜索模态框
				is_show_create: false, // 是否显示添加模态框
				data_list: [], // 表格数据
				loading: true,
			};
		},
		filters: {
			parseTime
		},
		created() {
			this.resetSearchData()
			this.getList()
			this.resetcreateManager()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1;
				this.getList()
			},

			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						'nick_name': ''
					},
				}
			},
			resetSearch() { // 重置搜索
				this.resetSearchData()
				this.getList()
			},
			resetcreateManager() { // 重置create_data数据
				this.create_data = {
					'id': '',
					'nick_name': '',
					'des': '',
					'role': [],
				}
			},
			handleCreate() { // 添加角色的按钮点击事件，角色数据模态框的显示和隐藏
				this.resetcreateManager();
				this.$nextTick(() => {
					this.$refs.tree.setCheckedNodes(this.create_data.role)
				})
				this.is_show_create = !this.is_show_create;
			},
			createManager() { // 角色添加提交
				this.$store.commit('setAjaxLoading', true);

				const checkedKeys = this.$refs.tree.getCheckedNodes(false, true)
				let role = [];
				for (let j = 0, len = checkedKeys.length; j < len; j++) {
					role[j] = {
						'title': checkedKeys[j].title,
						'path': checkedKeys[j].path
					}
				}
				this.create_data.role = role;
				roleSet(Qs.stringify(this.create_data)).then(response => {
					this.getList();
					this.is_show_create = !this.is_show_create;
					this.$message({
						showClose: true,
						message: '提交成功',
						type: 'success'
					});
				})
			},
			handleUpdate(row) { // 编辑角色的按钮点击事件，角色数据模态框的显示和隐藏
				this.create_data = Object.assign({}, row) // copy obj
				this.is_show_create = !this.is_show_create;
				this.$nextTick(() => {
					this.$refs.tree.setCheckedNodes(this.create_data.role)
				})

			},
			handleDelete(row, index) { // 角色的删除
				roleDel(Qs.stringify(row)).then(response => {
					this.data_list.splice(index, 1)
					this.$message({
						showClose: true,
						message: '删除成功',
						type: 'success'
					});
				})
			},
			getList() { // 获取列表数据
				this.loading = true;
				roleList(Qs.stringify(this.listQuery)).then(response => {
					this.data_list = response.result.items;
					this.total = response.result.total;
					this.loading = false;
				})
			},
		}
	}
</script>
